var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConstructionEdit',_vm._g(_vm._b({},'ConstructionEdit',{
    construction: _vm.construction
  },false),{ ok: _vm.ok, cancel: _vm.cancel }))}
var staticRenderFns = []

export { render, staticRenderFns }